/**
 * Largest request body the server accepts for an upload (nginx
 * `client_max_body_size 2g`, i.e. 2 GiB). A bulk import sends all its files in
 * one request, so the limit applies to their sum. 1 MiB stays free for the
 * multipart boundaries and the `options` JSON that travel with the files.
 */
export const MAX_UPLOAD_REQUEST_BYTES = 2 * 1024 ** 3 - 1024 ** 2;

/** The limit as users read it ("2 GB"), for messages. */
export const MAX_UPLOAD_REQUEST_LABEL_BYTES = 2 * 1024 ** 3;
